import { createFileRoute } from '@tanstack/react-router';
import { TransportadorPageList } from '@/features/transportador/page/list/TransportadorPageList';

export const Route = createFileRoute('/a/transportador/')({
    component: TransportadorPageList,
});
